import { IComponentController } from 'angular';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';

interface IPageRe0016 extends IComponentController {
    monoOccurrence: IMonoOccurrence;
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    formulaireOpc: IFormulaire;
    ousMultiOccurrenceOptions: IMultiOccurrenceOptions;
    valeursEcran: any;
}
/* @ngInject */
export default function Re0016Controller(
    ecranDetails: IEcranDetailsResourcesEntite, 
    Formulaire: IFormulaireClass, 
    FormulaireItem: IFormulaireItemClass) {

    const vm: IPageRe0016 = this;

    vm.valeursEcran = ecranDetails.valeurs;

    vm.monoOccurrenceOptions = {
        id: vm.valeursEcran.opccleint,
        fonctions: {
            boutonDupliquer: false
        }
    };

    vm.formulaireOpc = new Formulaire('LBL_BLC_OPC', [
            new FormulaireItem('ttccleintlem')
        ]
    );

    vm.ousMultiOccurrenceOptions = {
        fonctions: {
            importation: true
        },
        bloc: 'ous',
        colonnesFixesGauche: [
            { nom: 'urgcod', largeur: 99 },
            { nom: 'strcod', largeur: 89 },
            { nom: 'strcodrpl', largeur: 93 },
            { nom: 'tlecodrpl', largeur: 99 }
        ],
        colonnesVisibles: [
            { nom: 'urgdscabr', largeur: 275 },
            { nom: 'strdsc', largeur: 262 },
            { nom: 'strdscrpl', largeur: 262 },
            { nom: 'tledscrpl', largeur: 262 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('urgcleint'), 
            new FormulaireItem('strcleint'), 
            new FormulaireItem('strcleintrpl'), 
            new FormulaireItem('tlecleintrpl')
        ])
    };
}
